import { render, staticRenderFns } from "./SourceTypeChart.vue?vue&type=template&id=6a049ee6"
import script from "./SourceTypeChart.vue?vue&type=script&lang=js"
export * from "./SourceTypeChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports